export function isObject(e){return e&&typeof e==="object"&&!Array.isArray(e)}/**
 * immutably merge two objects
 * using a custom function over lodash to keep default bundle sizes low
 * citation: https://stackoverflow.com/a/37164538/1790362
 * @param target object to base merge from (immutably)
 * @param source object to merge
 * @returns new object
 */export function mergeDeep(e,t){let i=Object.assign({},e);if(isObject(e)&&isObject(t)){Object.keys(t).forEach(s=>{if(isObject(t[s])){if(!(s in e)){Object.assign(i,{[s]:t[s]})}else{i[s]=mergeDeep(e[s],t[s])}}else{Object.assign(i,{[s]:t[s]})}})}return i}